import * as React from "react";

function SvgLocationIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 28 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M14 .625C6.754.625.875 5.917.875 12.438.875 22.938 14 37.374 14 37.374s13.125-14.438 13.125-24.938C27.125 5.918 21.245.626 14 .626zM14 19a5.25 5.25 0 110-10.499A5.25 5.25 0 0114 19z"
                fill="#6C9F39"
            />
        </svg>
    );
}

export default SvgLocationIcon;
